window.vsvars = {
    version_number: "9.8.59",
    release_date: "September 26, 2026",
    modelsjson_version: "5048ed",
    cdnurl: "https://static.hamrick.com",
    baseurl: "https://www.hamrick.com",
    backendurl: "https://www.hamrick.com/a"
};
